type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export const storage = {
  set: (key: StorageKey, value: string) => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(key, value);
    }
  },
  get: (key: StorageKey) => {
    if (typeof window !== "undefined") {
      return sessionStorage.getItem(key);
    }
    return null;
  },
  remove: (key: StorageKey) => {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem(key);
    }
  },
};

export const STORAGE_KEYS = {
  PERSONAL_DETAILS: "personalDetails",
  ORDER_TYPE: "orderType",
  ADDRESS: "address",
  /**
   * Flash promotion ids the customer actually engaged with — dismissed or
   * redeemed. Those are decisions, so they suppress the campaign for the rest
   * of the session. JSON array.
   *
   * Deliberately NOT the old "flashPromosSeen": that key also collected
   * campaigns that merely expired unwatched, which we no longer treat as a
   * decision. Old entries are indistinguishable from real dismissals, so the
   * rename retires them rather than honouring state that means something else.
   */
  FLASH_PROMOS_DISMISSED: "flashPromosDismissed",
  /**
   * How many times each campaign has counted down and expired unengaged.
   * Expiring is not a decision — the customer may simply have been reading the
   * menu — so it does not suppress on its own until it has had a few goes.
   * JSON object of id -> count.
   */
  FLASH_PROMOS_EXPIRED: "flashPromosExpired",
} as const;
